import { render, staticRenderFns } from "./VChartComponent.vue?vue&type=template&id=6690d2b5&scoped=true"
import script from "./VChartComponent.vue?vue&type=script&lang=js"
export * from "./VChartComponent.vue?vue&type=script&lang=js"
import style0 from "./VChartComponent.vue?vue&type=style&index=0&id=6690d2b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6690d2b5",
  null
  
)

export default component.exports